<template>
  <div class="container-binnacle">
    <app-timeline>
      <app-timeline-item
        v-for="binnacle in binnacleFile"
        :key="binnacle.bitacoraId"
        icon="InfoIcon"
        :variant="getSeverity(binnacle.severidad)"
      >
        <div
          class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        >
          <h6>{{binnacle.usuarioNombre}}</h6>
          <small class="text-muted">
            {{binnacle.fecha | dateCompleteFormat}}
          </small>
        </div>
        <div
          class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        >
          <p>{{binnacle.mensaje}}</p>
          <div class="mb-1 mb-sm-0">
            <div>
              <b-avatar
                v-if="binnacle.tipoVista == -1 || binnacle.tipoVista == 0"
                v-b-tooltip.hover title="Registro Visible solo para Admin"
                text="O"
                class="mr-50"
                size="24"
                icon="eye-slash-fill"
                variant="secondary"
              />
              <b-avatar
                v-has-permission="'FEB99'"
                v-b-tooltip.hover
                title="Copiar Seguimiento"
                text="S"
                class="mr-50 add-code"
                size="24"
                icon="bug"
                variant="success"
                @click.native="copyToClipboard(binnacle.seguimientoId)"
              />
            </div>
          </div>
        </div>
      </app-timeline-item>
    </app-timeline>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

import AppTimeline from '@core/components/app-timeline/AppTimeline';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';

export default {
  name: 'Binnacle',
  mixins: [CopyToClipboard],
  components: {
    AppTimeline,
    AppTimelineItem
  },
  computed: {
    ...mapGetters('Approvals', [
      'binnacleFile'
    ])
  },
  methods: {
    getSeverity(severity) {
      switch (severity) {
        case 1: return 'info';
        case 2: return 'warning';
        case 3: return 'danger';
        default: return 'secondary';
      }
    }
  }
};
</script>
<style>
.container-binnacle {
  height: 250px;
  overflow-y: scroll;
}

</style>
